export enum NfeStatusEnum {
    PENDING = 'PENDING',
    AUTHORIZED = 'AUTHORIZED',
    DENIED = 'DENIED',
    CANCELED = 'CANCELED',
    CANCELLATION_DENIED = 'CANCELLATION_DENIED'
}